(function(){
  // ===== Helpers =====
  function readHook(){
    return document.querySelector('script[data-rv-container-id][data-rv-count]');
  }

  function formatMoney(cents, moneyFormat, currency){
    var out;
    try{
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        out = Shopify.formatMoney(cents, moneyFormat);
      } else {
        out = (cents/100).toLocaleString(undefined,{style:'currency',currency:currency});
      }
    }catch(e){ out = (cents/100).toFixed(2); }

    if (currency === 'AUD') {
      out = out.replace(/^A\$/,'$').replace(/\s?AUD\b/g,'');
    }
    return out.trim();
  }

  var storageKey = 'rv:handles:v1';
  function getHandles(){
    try{ return Array.from(new Set((JSON.parse(localStorage.getItem(storageKey))||[]).filter(Boolean))); }
    catch(e){ return []; }
  }
  function saveHandles(list){
    try{ localStorage.setItem(storageKey, JSON.stringify(list.slice(0,20))); }catch(e){}
  }
  function seedCurrent(currentHandle){
    if(!currentHandle) return;
    var list = getHandles();
    if(!list.includes(currentHandle)){ list.unshift(currentHandle); saveHandles(list); }
  }

  var productCache = new Map();
  function fetchProduct(handle){
    if(productCache.has(handle)) return Promise.resolve(productCache.get(handle));
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ productCache.set(handle, p); return p; })
      .catch(function(){ return null; });
  }

  function minPrices(p){
    var prices   = (p && p.variants||[]).map(function(v){ return +v.price; }).filter(Number.isFinite);
    var compares = (p && p.variants||[]).map(function(v){ return v.compare_at_price ? +v.compare_at_price : Infinity; });
    var minPrice = prices.length ? Math.min.apply(null, prices) : (+((p||{}).price||0));
    var compMin  = compares.length ? Math.min.apply(null, compares) : Infinity;
    return { minPrice: minPrice, compMin: Number.isFinite(compMin)&&compMin>0?compMin:null };
  }

  function extractHandleFromHref(href){
    var m = (href||'').match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function injectPriceIntoCard(card, moneyFormat, currency, data){
    try{
      if(!card || !data) return;
      // Avoid duplicates
      if(card.querySelector('.rv-price-line')) return;

      // Prefer to place right under the title block
      var titleLink = card.querySelector('a[href*="/products/"]');
      var anchor = titleLink ? (titleLink.parentElement || card) : card;

      var prices = minPrices(data);
      var line = document.createElement('div');
      line.className = 'rv-price-line';

      var html = '<span class="rv-price-amount">' + formatMoney(prices.minPrice, moneyFormat, currency) + '</span>';
      if(prices.compMin && prices.compMin > prices.minPrice){
        html += '<span class="rv-price-compare">' + formatMoney(prices.compMin, moneyFormat, currency) + '</span>';
      }
      line.innerHTML = html;
      anchor.appendChild(line);
    }catch(e){}
  }

  function normalizeInfoHeights(container){
    try{
      var infos = Array.prototype.slice.call(container.querySelectorAll('.product-card__info'));
      if(!infos.length) return;
      infos.forEach(function(el){ el.style.minHeight = ''; });
      var max = 0;
      infos.forEach(function(el){ max = Math.max(max, el.offsetHeight); });
      if (max > 0){ infos.forEach(function(el){ el.style.minHeight = max + 'px'; }); }
    }catch(e){}
  }

  // ===== Main enhancer =====
  function enhanceContainer(container, count, moneyFormat, currency){
    if(!container) return;

    var cards = Array.prototype.slice.call(container.children).slice(0, count);
    if(!cards.length){ normalizeInfoHeights(container); return; }

    // Build list for all cards (we'll skip inject if already present)
    var pairs = cards.map(function(card){
      var link = card.querySelector('a[href*="/products/"]');
      var handle = extractHandleFromHref(link ? link.getAttribute('href') : '');
      return handle ? { card: card, handle: handle } : null;
    }).filter(Boolean);

    if(!pairs.length){ normalizeInfoHeights(container); return; }

    Promise.all(pairs.map(function(x){
      return fetchProduct(x.handle).then(function(p){ return {card:x.card, data:p}; });
    })).then(function(list){
      list.forEach(function(item){
        if(item && item.data) injectPriceIntoCard(item.card, moneyFormat, currency, item.data);
      });
      // Align baselines after DOM updates settle
      requestAnimationFrame(function(){ normalizeInfoHeights(container); });
    });
  }

  function init(){
    var hook = readHook();
    if(!hook) return;

    var containerId   = hook.getAttribute('data-rv-container-id');
    var count         = parseInt(hook.getAttribute('data-rv-count') || '5', 10);
    var currentHandle = hook.getAttribute('data-rv-current-handle') || null;
    var moneyFormat   = hook.getAttribute('data-rv-money-format') || '${{amount}}';
    var currency      = hook.getAttribute('data-rv-currency') || 'USD';

    var container = document.getElementById(containerId);
    if(!container) return;

    seedCurrent(currentHandle);

    // First pass
    enhanceContainer(container, count, moneyFormat, currency);

    // Observe re-renders and re-inject + re-align
    var debounce;
    var mo = new MutationObserver(function(){
      clearTimeout(debounce);
      debounce = setTimeout(function(){
        enhanceContainer(container, count, moneyFormat, currency);
      }, 80);
    });
    mo.observe(container, { childList: true, subtree: true });

    // Theme editor events
    document.addEventListener('shopify:section:load', function(e){
      if(e && e.target && e.target.contains(container)){
        enhanceContainer(container, count, moneyFormat, currency);
      }
    });
    document.addEventListener('shopify:section:reorder', function(){
      enhanceContainer(container, count, moneyFormat, currency);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  